import { Image } from 'react-bootstrap';
import { Container } from 'reactstrap';

export const AdminHome = ({ fullName }) => {

    return (
        <Container>
            <div>
                <div>
                    <h1><u>Ленинград центр Online</u></h1>
                    <p>{fullName}, добрый день!</p>
                </div>
                <div>
                    <Image style={{maxHeight: '100px'}} fluid src={`https://app.leningradcenter.ru/api/qrcode?text=${fullName}`} />
                </div>
            </div>
        </Container>
    );
}
